import { FC } from "react";
import CommonLayout from "./CommonLayout";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { selectBookings } from "application/features/bookings/bookingsSlice";
import CalendarPage from "containers/Calendar/CalendarPage";

export interface PageAddListing1Props {}

const PageCalendarStep: FC<PageAddListing1Props> = () => {

  const navigate = useNavigate();
  const params = useParams<{ prevUrl: string }>();
  const prevUrl = params.prevUrl ? decodeURIComponent(params.prevUrl) : "/client";
  const bookings = useSelector(selectBookings);

  console.log("bookings in calendar step", bookings);

  if (!bookings || bookings.length === 0) {
    // redirect to client home if no bookings found
    navigate("/client");
  }

  return (
    <CommonLayout
      index="1"
      backtHref={prevUrl}
      nextHref={`/client/booking/summary`}
      canGoNext={true}
    >
      <CalendarPage />
    </CommonLayout >
  );
};

export default PageCalendarStep;
